import { Tab } from 'react-dsgov';
import { useEffect, useState } from 'react';
import {
  IDeclaracaoTitularArrendatarioNaoIniciada,
  IDeclaracaoTitularOuArrendatarioExistente,
} from '../../../../interfaces/IDeclaracoes';
import { NaoIniciadaTable } from '../declaracoesTables/naoIniciadaTable/naoIniciadaTable';
import { ExistentesTable } from '../declaracoesTables/existenteTable/existenteTables';

interface ICustomTab {
  declaracoesData: IDeclaracaoTitularOuArrendatarioExistente[];
  declaracoesNaoIniciadasData: IDeclaracaoTitularArrendatarioNaoIniciada[];
  isDeclaracoesNaoIniciadasLoading: boolean;
  isDeclaracoesExistentesLoading: boolean;
  declaracaoType: 'titular-ou-arrendatario';
}

function CustomTabTitularArrendatario({
  declaracoesData,
  declaracoesNaoIniciadasData,
  isDeclaracoesNaoIniciadasLoading,
  isDeclaracoesExistentesLoading,
  declaracaoType,
}: ICustomTab) {
  const [emPreenchimentoData, setEmPreenchimentoData] = useState<IDeclaracaoTitularOuArrendatarioExistente[]>([]);
  const [entregueData, setEntregueData] = useState<IDeclaracaoTitularOuArrendatarioExistente[]>([]);
  const [naoIniciada, setNaoIniciada] = useState<IDeclaracaoTitularArrendatarioNaoIniciada[]>([]);

  useEffect(() => {
    if (declaracoesData) {
      setEmPreenchimentoData(declaracoesData.filter((declaracao) => declaracao.statusDeclaracao === 0));
      setEntregueData(
        declaracoesData.filter((declaracao) => declaracao.statusDeclaracao === 1 || declaracao.statusDeclaracao === 2)
      );
      setNaoIniciada(declaracoesNaoIniciadasData);
    }
  }, [declaracoesData, declaracoesNaoIniciadasData]);

  return (
    <Tab density='small'>
      <Tab.Content title='Não iniciada' icon='fas fa-file'>
        <NaoIniciadaTable data={naoIniciada} isLoading={isDeclaracoesNaoIniciadasLoading} page={declaracaoType} />
      </Tab.Content>

      <Tab.Content title='Em Preenchimento' icon='fas fa-file-signature'>
        <ExistentesTable
          data={emPreenchimentoData}
          headers={[
            { field: 'tipoDeclaracao', label: 'Tipo' },
            { field: 'declarante', label: 'Declarante' },
            { field: 'exercicio', label: 'Exercício' },
            { field: 'acao-editar', label: 'Ação' },
          ]}
          isLoading={isDeclaracoesExistentesLoading}
          tab='Em Preenchimento'
          page={declaracaoType}
        />
      </Tab.Content>
      <Tab.Content title='Entregue' icon='fas fa-file-upload'>
        <ExistentesTable
          data={entregueData}
          headers={[
            { field: 'tipoDeclaracao', label: 'Tipo' },
            { field: 'status', label: 'Status' },
            { field: 'declarante', label: 'Declarante' },
            { field: 'numeroRecibo', label: 'Recibo' },
            { field: 'exercicio', label: 'Exercício' },
            { field: 'acao-visualizar', label: 'Ação' },
          ]}
          isLoading={isDeclaracoesExistentesLoading}
          tab='Entregue'
          page={declaracaoType}
        />
      </Tab.Content>
    </Tab>
  );
}

export default CustomTabTitularArrendatario;
